export default "__VITE_ASSET__UbdIDFcl__"